"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var richContentUtils_1 = require("../utils/richContentUtils");
var commentsView_1 = require("./commentsView");
var Clipboard = require("clipboard");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        _super.call(this, options);
        richContentUtils_1.default.processHtml(".art-description");
        var urlClipboard = new Clipboard("#artUrl");
        urlClipboard.on("success", function () {
            alert("Ссылка на иллюстрацию скопирована.");
            app.closeModal();
        });
        urlClipboard.on("error", function (e) {
            var $el = $(e.trigger);
            var url = $el.attr("data-clipboard-target");
            prompt("Ссылка на иллюстрацию", url);
            app.closeModal();
        });
        this.loadComments(null, null, false);
    }
    return ViewModel;
}(commentsView_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=artView.js.map